import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Exibe sempre a notificação mais recente da fila, em formato "toast".
 */
export default function CentralNotificacoesToast({ fila, removerNotificacao }) {
  useEffect(() => {
    if (fila.length > 0) {
      const timer = setTimeout(() => removerNotificacao(fila[0].id), 6000);
      return () => clearTimeout(timer);
    }
  }, [fila, removerNotificacao]);

  return (
    <div className="fixed top-5 right-5 z-[9999] max-w-sm space-y-2">
      <AnimatePresence>
        {fila[0] && (
          <motion.div
            key={fila[0].id}
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.5, type: 'spring' }}
            className="bg-white shadow-xl rounded-xl border border-gray-300 flex items-center space-x-4 p-4"
          >
            <div className="w-12 h-12">{fila[0].icone}</div>
            <div>
              <div className="font-semibold">{fila[0].titulo || 'Notificação'}</div>
              <div className="text-sm">{fila[0].mensagem}</div>
              {fila[0].acao && (
                <button
                  className="mt-2 px-2 py-1 rounded text-xs bg-blue-100 hover:bg-blue-200"
                  onClick={fila[0].acao.onClick}
                >
                  {fila[0].acao.label}
                </button>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}